import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreMaterialModule } from '@nttp/core-material';
import { CheckAccountComponent } from '@pg-app/client/client-dashboard/dialogs/check-account/check-account.component';

@NgModule({
    imports: [CommonModule, CoreMaterialModule],
    declarations: [CheckAccountComponent],
    entryComponents: [CheckAccountComponent]
})
export class CheckAccountModule { }